import React, {
  PropsWithChildren,
} from 'react';
import Row from 'pages/Dashboard/components/Row';
import SendTempoLinkButton from 'pages/Dashboard/pages/Charts/pages/Details/components/Demographics/SendTempoLinkButton';
import CallForCCMButton from 'pages/Dashboard/pages/Charts/pages/Details/components/Demographics/CallForCCMButton';
import SendRTMActionButton from 'pages/Dashboard/pages/Charts/pages/Details/components/Demographics/SendRTMActionButton';
import {
  EncounterViewModel,
} from 'dtos';
import useEMRAccess from 'views/EMR/hooks/useEMRAccess';

type Props = {
  encounter: EncounterViewModel;
};

type ActionRowProps = PropsWithChildren<{
  title: string;
}>;

function ActionRow({
  title,
  children,
}: ActionRowProps) {
  return (
    <Row
      title={title}
      className="!px-4 !py-3 !items-start"
    >
      <div className="flex gap-2 items-center">
        {children}
      </div>
    </Row>
  );
}

export default function PCCActions({ encounter }: Props) {
  const {
    canSendTempoCommunique,
    canUseCCMAgent,
    canUseRTMMonitoring,
  } = useEMRAccess();
  const patientId = encounter.patient?.patientId ?? 0;
  const encounterId = encounter.encounterId ?? 0;
  const hasActions = canSendTempoCommunique || canUseCCMAgent || canUseRTMMonitoring;

  return !hasActions ? null : (
    <>
      {canSendTempoCommunique && (
        <ActionRow title="Tempo">
          <SendTempoLinkButton
            patientId={patientId}
            encounterId={encounterId}
          />
        </ActionRow>
      )}
      {canUseCCMAgent && (
        <ActionRow title="CCM">
          <CallForCCMButton patientId={patientId} />
        </ActionRow>
      )}
      {canUseRTMMonitoring && (
        <ActionRow title="RTM">
          <SendRTMActionButton patientId={patientId} />
        </ActionRow>
      )}
    </>
  );
}
